import { getCountryCodes } from '@utils/CountryUtils';
import { getBaseTimePeriodForMATAndYTD, getPeriodicityForMATAndYTD } from '@utils/PeriodUtils';
import {
  addAllProductGroupFilter,
  addPgLoadedTagInPlace,
  getGeneralCollectionInsightTags,
  getIsUsingCollectionLiveData,
  getPeriodLabel,
} from '@utils/collectionUtils/CollectionUtils';
import { RetailerOverviewLineChartInsight } from './Model';

export const getRetailerOverviewLineChartInsightInfoTags = async (insight: RetailerOverviewLineChartInsight) => {
  const {
    apiParams: { clientId, periodType, appliedFilters, period, comparisonPeriod, countries, productType, productGroup },
    collectionDataType,
    retailerClientName,
  } = insight;

  const baseTimePeriod = getBaseTimePeriodForMATAndYTD(period, periodType);
  const { periodicity } = getPeriodicityForMATAndYTD(baseTimePeriod, periodType);
  const finalAppliedFilters = addAllProductGroupFilter(appliedFilters);

  const countryIds: string[] = getCountryCodes(countries);
  const periodLabel = await getPeriodLabel({
    clientId,
    periodicity,
    baseTimePeriod,
    comparisonPeriod,
    countryIds,
    productType,
    collectionDataType: getIsUsingCollectionLiveData(period, collectionDataType) ? 'live' : collectionDataType,
    productGroups: productGroup,
  });

  const baseTags = getGeneralCollectionInsightTags({
    periodType: periodicity,
    comparisonPeriod:
      typeof comparisonPeriod === 'object' && comparisonPeriod !== null
        ? JSON.stringify(comparisonPeriod)
        : String(comparisonPeriod),
    appliedFilters: finalAppliedFilters,
    period: periodLabel,
    selectedGrowthType: '',
    retailerClientName: retailerClientName,
  });

  await addPgLoadedTagInPlace(baseTags, insight.apiParams, collectionDataType);

  return baseTags;
};
